module.exports = __webpack_public_path__ + "fonts/file-exception.svg?4fd89eb6";